import { render, staticRenderFns } from "./custome-line.vue?vue&type=template&id=615ed930"
import script from "./custome-line.vue?vue&type=script&lang=js"
export * from "./custome-line.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports